// extracted by mini-css-extract-plugin
export default {"pre":"ComplaintFormImpulseProductData-m5Ok1__pre","serialImage":"ComplaintFormImpulseProductData-d1fkE__serialImage"};